import { useMockAlpheraProposal, useMockBnpProposal, useMockCloseProposal, useMockZopaProposal, useMockHpProposal, useMockMotonovoProposal, useMockNorthridgeProposal } from "../";
import useMockCaProposal from "./use-mock-ca-proposal";
import useMockV12Proposal from "./use-mock-v12-proposal";

export default function useMockPrimeProposals(price: number) {
  return [
    useMockAlpheraProposal(price),
    useMockNorthridgeProposal(price),
    useMockCloseProposal(price),
    useMockZopaProposal(price),
    useMockMotonovoProposal(price),
    useMockCaProposal(price),
    useMockV12Proposal(price),
    useMockHpProposal(price)
  ]
}
